import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './index-pc.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

/*

Carta para o próximo azarado que tiver que tocar nesse código!!!

Este projeto é o motivo pelo qual tenho que fazer terapia.

Olá, sou um dev que está no desenvolvimento desse projeto.
Digo por meio deste, que peço que Deus abençoe quem for mexer nesse sistema.

Esse prejeto gerou muitas dores e estresse, saímos com 2 devs traumatizados.

Eu me recuso a tocar a mão nesse projeto de novo, se eu tiver que ouvir falar em mexer nesse projeto, será apenas para supervisionar se precisarmos de pequenas correções, que outro dev mexa nele. Isso já está há muito tempo em desenvolvimento e nunca anda para frente, já chegamos a terminar esse projeto, mas os clientes não se decidem sobre o que precisam no sistema.

Os clientes são dois irmãos, um é focado e sabe exatamente o que quer no sistema, enquanto o outro é mais viajado e não tem foco nas funcionalidades e pontos importantes do projeto.

Cuidado!!!

Assinado por "Um cara sensato"

*/